// Form 19 Columns, CSC Dropdowns & Insurance Master UI Alignment Updated: 2026-08-24 16:59
/* eslint-disable quotes */
/* eslint-disable react/destructuring-assignment */
import React, { PureComponent, useContext, useEffect, useState } from "react";
import { withRouter, Route } from "react-router-dom";

// Components
import Manufacturers from "../CompanyMasters/Manufacturers";
import Employee from "../CompanyMasters/Employee";
import SACCode from "../CompanyMasters/SACCode";
import BinLocation from "../CompanyMasters/BinLocation";
import Country from "../CompanyMasters/Country";
import State from "../CompanyMasters/State";
import City from "../CompanyMasters/City";
import District from "../CompanyMasters/District";
import Locality from "../CompanyMasters/Locality";
import Financier from "../CompanyMasters/Financier";
import Insurance from "../CompanyMasters/Insurance Master";
import HSNCode from "../CompanyMasters/HSNCode";
import Department from "../CompanyMasters/Departments";
import JobCode from "../CompanyMasters/JobCode";
import Accessories from "../CompanyMasters/Accessories";
import VehiclePrice from "../CompanyMasters/VehiclePrice";
import PartsMaster from "../CompanyMasters/PartsMaster";
import VehicleMaster from "../CompanyMasters/VehicleMaster";
import ServiceScheduleMaster from "../CompanyMasters/ServiceScheduleMaster";
import SMS from "../CompanyMasters/SMS";
import SupplierMaster from "../CompanyMasters/SupplierMaster";
import Company from "../CompanyMasters/Company";
import VehiclePurchaseInvoice from "../TransactionMasters/VehiclePurchaseInvoice";
import PurchaseReturn from "../TransactionMasters/PurchaseReturn";
import Vehicles from "../TransactionMasters/Vehicles";
// import SalesChallan from "../TransactionMasters/SalesChallan";
import Customers from "../TransactionMasters/CustomerDetails";
import BookingRegister from "../TransactionMasters/BookingRegister";
import SalesRegister from "../TransactionMasters/SalesRegister";
import Quotation from "../TransactionMasters/Quotations";
import VehicleSaleInvoice from "../TransactionMasters/VehicleSaleInvoice";
import JobOrder from "../TransactionMasters/JobOrder";
import GatePassVerification from "../TransactionMasters/GatePassVerification";
import VehiclePurchaseChallan from "../TransactionMasters/VehiclePurchaseChallan";
import IDGenerator from "../CompanyMasters/IDGenerator";
import NotFound from "../NotFound";
import Forbidden from "../Forbidden";
import ReferredCustomerPage from "../TransactionMasters/ReferredCustomerPage";
import { ContextAPI } from "../../ContextAPI";
import Sales from "../Services/Sales";
import { submodules } from "../../JSONFiles/Submodule.json";
import Promotions from "../TransactionMasters/Promotions";
import RTOMaster from "../CompanyMasters/RTOMaster";
import FrameNumber from "../CompanyMasters/FrameNumber";
import Dashboard from "../Dashboard";
import FollowUps from "../FollowUp";
import FollowUpHomePage from "../FollowUp/HomePage";
import SalesTargets from "../CompanyMasters/SalesTargets";
import PMC from "../CompanyMasters/PMC";
import Reports from "../TransactionMasters/Reports";
import PurchaseSparesTable from "../TransactionMasters/PurchaseSparesInvoice";
import PurchaseSparesInvoice from "../TransactionMasters/PurchaseSparesInvoice/Invoice";
import SparseInventory from "../CompanyMasters/SparesInventory";
import SparesInventory from "../CompanyMasters/SparesInventory";
import VehicleInventory from "../CompanyMasters/VehicleInventory";
// import StockCheck from "../TransactionMaster/StockCheck";    //updated
import SaleSparesInvoice from "../TransactionMasters/SaleSparesInvoice/Invoice";
import SaleSparesTable from "../TransactionMasters/SaleSparesInvoice";
import VehicleSaleInvoiceTable from "../TransactionMasters/VehicleSaleInvoice/VehicleSaleInvoiceTable";
import EstimateTable from "../TransactionMasters/Estimate";
import EstimateInvoice from "../TransactionMasters/Estimate/Invoice";
import MaterialIssueTable from "../TransactionMasters/MaterialIssue";
import MaterialIssueForm from "../TransactionMasters/MaterialIssue/MaterialIssueForm";
import LabourPerformList from "../TransactionMasters/LabourPerform";
import LabourPerformForm from "../TransactionMasters/LabourPerform/LabourPerformForm";
import WrappedServiceReminder from "../TransactionMasters/ServiceReminder";
import ServiceDashboard from "../ServiceDashboard";
import LedgerDetails from "../TransactionMasters/LedgerDetails";
import Ledger from "../TransactionMasters/Ledger";
import ServiceFollowUp from "../ServiceFollowUp";
import WrappedServiceFollowUpHome from "../ServiceFollowUp/ServiceFollowUpHome";
import FinalInspection from "../TransactionMasters/FinalInspection";
import WrappedFinalInspectionForm from "../TransactionMasters/FinalInspection/FinalInspectionForm";
import Whatsup from "../CompanyMasters/Whatsup";
import JobInvoiceTable from "../TransactionMasters/JobInvoice";
import JobInvoice from "../TransactionMasters/JobInvoice/Invoice";
import ReportDashboard from "../TransactionMasters/ReportDashboard";
import WhatsappWeb from "../CompanyMasters/Whatsup/WhatsappWeb";
import CustomerSpareOrder from "../TransactionMasters/CustomerSpareOrder";
import CustomerSpareOrderForm from "../TransactionMasters/CustomerSpareOrder/CustomerSpareForm";
import PurchaseInvoice from "../TransactionMasters/VehiclePurchaseInvoice/VehiclePurchaseInvoiceForm";
import StockCheck from "../TransactionMasters/Reports/StockCheck";
import WhatsappPromo from "../TransactionMasters/Promotions/WhatsappPromotions";
// import VehicleForm from "../Vehicles/VehicleForm";
import Upload from "../CompanyMasters/Upload"
import Transfer from "../TransactionMasters/Transfer";
import NumberPlating from "../TransactionMasters/NumberPlating";
import InsuranceReminder from "../TransactionMasters/InsuranceReminder";
import InsuranceFollowUp from "../TransactionMasters/InsuranceReminder/InsuranceFollowUp";
import OtherInsuranceReminder from "../TransactionMasters/OtherInsuranceReminder";
import OtherInsuranceFollowUp from "../TransactionMasters/OtherInsuranceReminder/OtherInsuranceFollowUp";
import CallLogs from "../TransactionMasters/CallLogs";
import Notifications from "../TransactionMasters/Notifications";
import AutoCaller from "../CompanyMasters/AutoCaller";
// import RingTone from "../CompanyMasters/RingTone";
import { useHistory } from "react-router-dom";
import Receipt from "../TransactionMasters/Receipt";
import PineLabs from "../CompanyMasters/PineLabs";
import SubDealer from "../CompanyMasters/SubDealer";
import Payment from "../TransactionMasters/Payment";
import CashWithdrawal from "../Accounts/CashWithdrawal";
import SalesFeedbackCall from "../TransactionMasters/SalesFeedbackCall";
import SalesFeedbackCallDetails from "../TransactionMasters/SalesFeedbackCall/CustomerDetails";
import ServiceFeedbackCall from "../TransactionMasters/ServiceFeedbackCall";
import ServiceFeedbackCallDetails from "../TransactionMasters/ServiceFeedbackCall/CustomerDetails";
import SpareAdjustment from "../TransactionMasters/SpareAdjustment";
import Form19 from "../CompanyMasters/Form19";
// import "";

const HelloReact = (props) => {
  const [persistentPage, setPersistentPage] = useState(false);
  const { loginCredintials } = useContext(ContextAPI);
  const history = useHistory();

  const type = props.match.params.type;
  const category = props.match.params.category;
  let dashboardAccess = Boolean(
    loginCredintials.departmentType?.some((type) => type === "Sales")
  );
  let serviceDashboardAccess = Boolean(
    loginCredintials.departmentType?.some((type) => type === "Service")
  );

  useEffect(() => {
    if (!type) {
      if (dashboardAccess) {
        history.push("/autoadmin/dashboard");
      } else if (serviceDashboardAccess) {
        history.push("/autoadmin/services");
      } else {
        history.push("/autoadmin/employee");
      }
    }
  }, [type, dashboardAccess, serviceDashboardAccess, history]);

  let access = false;

  useEffect(() => {
    submodules.map((e) => {
      if (e.key === type) {
        setPersistentPage(true);
      }
    });
  }, []);

  loginCredintials.roleAccess &&
    loginCredintials.roleAccess.map((each) => {
      if (
        (each.subModule === type && each.access && each.access.read === true) ||
        type === "job-order" ||
        (type === "referred_customer" &&
          each.subModule === "customer_details" &&
          each.access &&
          each.access.read === true) ||
        (type === "follow-ups" &&
          each.subModule === "quotations" &&
          each.access &&
          each.access.create === true) ||
        type === "counter_sale" ||
        type === "sales_targets" ||
        type === "pmc" ||
        type === "upload" ||
        type === "report" ||
        type === "purchase_spares_invoice" ||
        type == "spares_inventory" ||
        type == "vehicle_inventory" ||
        ((type === "stockcheck" || type === "stock_check") &&
          ["stockcheck", "stockcity", "stockinward", "stockchecking"].includes(
            (each.subModule || "").toLowerCase().replace(/[-_]/g, "")
          ) &&
          each.access &&
          each.access.read === true) ||
        type === "estimate" ||
        type === "transfer" ||
        type === "service_reminder" ||
        (type === "service-followups" &&
          each.subModule === "service_reminder" &&
          each.access &&
          each.access.create === true) ||
        type === "ledger" ||
        type === "number_plating" ||
        (type === "whatsup" && each.subModule === "whatsapp" && each.access && each.access.read === true) ||
        (type === "whatsapp" && each.subModule === "whatsapp_web" && each.access && each.access.read === true) ||
        type === "customerspare" || type === "customerspare" ||
        type === "other_insurance_renewal_reminder" || type === "call_logs" || type === "notifications" || type == "sales_register" || type == "receipt" || type == "payment" ||
        (type === "PineLabs" &&
          each.subModule === "Pine Labs" &&
          each.access &&
          each.access.read === true) ||
        type === "SubDealer" || type === "district" || type === "locality" || type == "groups" || type == "tasks" || type == "promotion" || type === "Cash_Withdrawal" ||
        ((type === "service_schedule") &&
          (each.subModule === "service_schedule" ||
           each.subModule === "Service Schedule") &&
          each.access &&
          each.access.read === true) ||
        type === "vehicle_sale_invoice" || type === "sales_feedback_call" || type === "service_feedback_call" || type === "spares_adjustment" || type === "ledger_details" ||
        ((type === "form_19" || type === "Form 19") && (each.subModule === "form_19" || each.subModule === "Form 19" || each.subModule === "Form19") && each.access && each.access.read === true) || type === "form_19"
      ) {
        access = true;
      }
      if (
        type === "company"
        // && each.subModule === 'company_settings'
        // && each.access && each.access.read === true
      ) {
        access = true;
      }
    });

  let component;
  if (type === "dashboard" && dashboardAccess) {
    component = <Dashboard />;
  } else if (type === "dashboard" && !dashboardAccess) {
    component = <Forbidden />;
  } else if (type === "services" && serviceDashboardAccess) {
    component = <ServiceDashboard />;
  } else {
    if (access) {
      switch (type) {
        // case "customerspare":
        //   component = <CustomerSpareOrder/>
        //   break;
        case "transfer":
          if (category === "vehicles") {
            component = <Transfer type="vehicles" />;
          } else if (category === "spares") {
            component = <Transfer type="spares" />;
          } else if (category == "number_plates") {
            component = <Transfer type="number_plates" />
          } else {
            component = <NotFound />;
          }
          break;

        case "number_plating":
          component = <NumberPlating />
          break;

        case "insurance_renewal_reminder":
          // component = <InsuranceReminder/>
          component = (
            <>
              <Route exact path="/autoadmin/insurance_renewal_reminder/">
                <InsuranceReminder />
              </Route>
              <Route
                exact
                path="/autoadmin/insurance_renewal_reminder/:phoneNumber"
              >
                <InsuranceFollowUp />
              </Route>
            </>
          )
          break;

        case "other_insurance_renewal_reminder":
          component = (
            <>
              <Route exact path="/autoadmin/other_insurance_renewal_reminder/">
                <OtherInsuranceReminder />
              </Route>
              <Route
                exact
                path="/autoadmin/other_insurance_renewal_reminder/:phoneNumber"
              >
                <OtherInsuranceFollowUp />
              </Route>
            </>
          )
          break;

        case "company":
          component = <Company />;
          break;
        case "manufacturer":
          component = <Manufacturers />;
          break;
        case "employee":
          component = <Employee />;
          break;
        case "sac":
          component = <SACCode />;
          break;
        case "bin_location":
          component = <BinLocation />;
          break;
        case "country":
          component = <Country />;
          break;
        case "state":
          component = <State />;
          break;
        case "city":
          component = <City />;
          break;
        case "district":
          component = <District />;
          break;
        case "locality":
          component = <Locality />;
          break;
        case "financier":
          component = <Financier />;
          break;
        case "insurance":
          component = <Insurance />;
          break;
        case "hsn":
          component = <HSNCode />;
          break;
        case "department":
          component = <Department />;
          break;
        case "auto_caller":
          component = <AutoCaller />;
          break;
        // case "ringtone":
        //   component = <RingTone />;
        //   break;
        case "job_code":
          component = <JobCode />;
          break;
        // case "accessories":
        //   component = <Accessories />;
        //   break;
        case "vehicle_price":
          component = <VehiclePrice />;
          break;
        case "vehicle_master":
          component = <VehicleMaster />;
          break;
        case "service_schedule":
          component = <ServiceScheduleMaster />;
          break;
        case "parts_master":
          component = <PartsMaster />;
          break;
        case "sms":
          component = <SMS />;
          break;
        case "whatsup":
          component = <Whatsup />;
          break;
        case "supplier_master":
          component = <SupplierMaster />;
          break;
        case "vehicle_purchase_invoice":
          component = <VehiclePurchaseInvoice />;
          component = (
            <>
              <Route exact path="/autoadmin/vehicle_purchase_invoice">
                <VehiclePurchaseInvoice />
              </Route>
              <Route exact path="/autoadmin/vehicle_purchase_invoice/:id">
                <PurchaseInvoice />
              </Route>
            </>
          );

          break;
        case "purchase_return":
          component = <PurchaseReturn />;
          break;
        case "vehicles":
          component = <Vehicles />;
          break;
        // case "sale_challan":
        //   component = <SalesChallan />;
        //   break;
        case "customer_details":
          component = <Customers />;
          break;
        case "call_logs":
          component = <CallLogs />;
          break;
        case "notifications":
          component = <Notifications />;
          break;
        case "booking_register":
          component = <BookingRegister />;
          break;
        case "sales_register":
          component = <SalesRegister />;
          break;
        case "sales_feedback_call":
          component = (
            <>
              <Route exact path="/autoadmin/sales_feedback_call">
                <SalesFeedbackCall />
              </Route>
              <Route exact path="/autoadmin/sales_feedback_call/:phone">
                <SalesFeedbackCallDetails />
              </Route>
            </>
          );
          break;
        case "service_feedback_call":
          component = (
            <>
              <Route exact path="/autoadmin/service_feedback_call">
                <ServiceFeedbackCall />
              </Route>
              <Route exact path="/autoadmin/service_feedback_call/:phone">
                <ServiceFeedbackCallDetails />
              </Route>
            </>
          );
          break;
        case "receipt":
          component = <Receipt />;
          break;
        case "payment":
          component = <Payment />;
          break;
        case "quotations":
          component = <Quotation />;
          break;
        case "vehicle_sale_invoice":
          component = <VehicleSaleInvoice />;
          break;
        case "job_order":
          component = <JobOrder />;
          break;
        case "gate_pass_verification":
          component = <GatePassVerification />;
          break;
        case "vehicle_purchase_challan":
          component = <VehiclePurchaseChallan />;
          break;
        case "idgenerator":
          component = <IDGenerator />;
          break;
        case "referred_customer":
          component = <ReferredCustomerPage />;
          break;
        case "sales":
          component = <Sales />;
          break;
        case "pmc":
          component = <PMC />;
          break;
        case "upload":
          component = <Upload />;
          break;
        case "PineLabs":
          component = <PineLabs />;
          break;
        case "SubDealer":
          component = <SubDealer />;
          break;
        case "form_19":
          component = <Form19 />;
          break;
        case "sales_targets":
          component = <SalesTargets />;
          break;
        case "spares_inventory":
          component = <SparesInventory />;
          break;
        case "vehicle_inventory":
          component = <VehicleInventory />;
          break;
        case "spares_adjustment":
          component = <SpareAdjustment />;
          break;
        // case "stock_check":
        //   component = <StockCheck />;     //updated
        //   break;
        case "service_reminder":
          component = <WrappedServiceReminder />;
          break;
        case "ledger_details":
          component = <LedgerDetails />;
          break;
        case "ledger":
          component = <Ledger />;
          break;
        // case "promowhatsapp":
        //   component = <WhatsappPromo />;
        //   break;
        case "purchase_spares_invoice":
          component = (
            <>
              <Route exact path="/autoadmin/purchase_spares_invoice">
                <PurchaseSparesTable />
              </Route>
              <Route exact path="/autoadmin/purchase_spares_invoice/:id">
                <PurchaseSparesInvoice />
              </Route>
            </>
          );
          break;
        case "customerspare":
          component = (
            <>
              <Route exact path="/autoadmin/customerspare">
                <CustomerSpareOrder />
                {/* <CustomerSpareOrderForm /> */}
              </Route>
              <Route exact path="/autoadmin/customerspare/:id">
                <CustomerSpareOrderForm />
              </Route>
            </>
          );
          break;
        case "counter_sale":
          component = (
            <>
              <Route exact path="/autoadmin/counter_sale">
                <SaleSparesTable />
              </Route>
              <Route exact path="/autoadmin/counter_sale/:id">
                <SaleSparesInvoice />
              </Route>
            </>
          );
          break;
        case "job_invoice":
          component = (
            <>
              <Route exact path="/autoadmin/job_invoice">
                <JobInvoiceTable />
              </Route>
              <Route exact path="/autoadmin/job_invoice/:id">
                <JobInvoice />
              </Route>
            </>
          );
          break;
        case "estimate":
          component = (
            <>
              <Route exact path="/autoadmin/estimate">
                <EstimateTable />
              </Route>
              <Route exact path="/autoadmin/estimate/:id">
                <EstimateInvoice />
              </Route>
            </>
          );
          break;
        case "material_issue":
          component = (
            <>
              <Route exact path="/autoadmin/material_issue">
                <MaterialIssueTable />
              </Route>
              <Route exact path="/autoadmin/material_issue/:id">
                <MaterialIssueForm />
              </Route>
              <Route exact path="/autoadmin/labour_perform">
                <LabourPerformList />
              </Route>
              <Route exact path="/autoadmin/labour_perform/:id">
                <LabourPerformForm />
              </Route>
            </>
          );
          break;
        case "labour_perform":
          component = (
            <>
              <Route exact path="/autoadmin/labour_perform">
                <LabourPerformList />
              </Route>
              <Route exact path="/autoadmin/labour_perform/:id">
                <LabourPerformForm />
              </Route>
            </>
          );
          break;
        case "final_inspection":
          component = (
            <>
              <Route exact path="/autoadmin/final_inspection">
                <FinalInspection />
              </Route>
              <Route exact path="/autoadmin/final_inspection/:id">
                <WrappedFinalInspectionForm />
              </Route>
            </>
          );
          break;
        case "promotion":
          if (category === "groups") {
            component = <Promotions type="groups" />;
          } else if (category === "tasks") {
            component = <Promotions type="tasks" />;
          } else {
            component = <NotFound />;
          }
          break;
        case "report":
          if (category === "spares") {
            component = <Reports type="spares" />;
          } else if (category === "vehicle") {
            component = <Reports type="vehicle" />;
          } else if (category === "denomination") {
            component = <Reports type="denomination" />;
          } else if (category === "ReportDashboard") {
            component = <ReportDashboard />
          }
          else {
            component = <NotFound />;
          }
          break;
        case "rtomaster":
          component = <RTOMaster />;
          break;
        case "frame_number":
          component = <FrameNumber />;
          break;
        case "follow-ups":
          component = (
            <>
              <Route exact path="/autoadmin/follow-ups/">
                <FollowUpHomePage />
              </Route>
              <Route
                exact
                path="/autoadmin/follow-ups/:phoneNo/fupdate/:fupDate"
              >
                <FollowUps />
              </Route>
            </>
          );
          break;

        case "stockcheck":
          component = (
            <>
              <Route
                exact
                path={["/autoadmin/stockcheck", "/autoadmin/stockcheck/"]}
              >
                <StockCheck />
              </Route>
            </>
          );
          break;

        case "service-followups":
          component = (
            <>
              <Route exact path="/autoadmin/service-followups/">
                <WrappedServiceFollowUpHome />
              </Route>
              <Route
                exact
                path="/autoadmin/service-followups/:phoneNo/fupdate/:fupDate"
              >
                <ServiceFollowUp />
              </Route>
            </>
          );
          break;

        case "whatsapp":
          component = (
            <>
              <Route exact path="/autoadmin/whatsapp">
                <WhatsappWeb />
              </Route>
            </>
          );
          break;

        case "Cash_Withdrawal":
          component = (
            <>
              <Route exact path="/autoadmin/Cash_Withdrawal">
                <CashWithdrawal />
              </Route>
            </>
          );
          break;

        default:
          component = <NotFound />;
      }
    } else {
      if (!persistentPage) {
        component = <NotFound />;
      } else {
        component = <Forbidden />;
      }
    }
  }

  return <div>{component}</div>;
};

export default withRouter(HelloReact);
